module.exports = __webpack_public_path__ + "img/LTE.bbcc0a1c.svg";